module.exports = __webpack_public_path__ + "img/message-sp-4.985bd221.jpg";